import {
  AuthConfig,
  AuthServices,
  DefaultLdsService,
  FirebaseUserAuthService,
  LdsSystem,
  Legal,
  LoginSettings,
} from '@phx-husky/auth-service';

const getServices = (
  ldsSettings: Legal[],
  loginSettings: LoginSettings | null | undefined
): AuthServices => ({
  userAuthService: {
    Class: FirebaseUserAuthService,
    params: {
      firebaseOptions: {
        apiKey: process.env.GATSBY_FIREBASE_AUTH_API_KEY as string,
        authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN as string,
        projectId: process.env.GATSBY_FIREBASE_AUTH_PROJECT_ID as string,
        appId: process.env.GATSBY_FIREBASE_AUTH_APP_ID,
      },
      userAttrCollectionName: process.env
        .GATSBY_FIREBASE_AUTH_DATABASE_USER_ATTR_COLLECTION_NAME as string,
      hasFacebookSignIn: Boolean(
        process.env.GATSBY_FIREBASE_AUTH_FACEBOOK_ENABLED
      ),
      hasGoogleSignIn: Boolean(process.env.GATSBY_FIREBASE_AUTH_GOOGLE_ENABLED),
      rememberMeConfig: {
        defaultValue: loginSettings?.rememberMeDefaultValue ?? false,
        show: loginSettings?.showRememberMe ?? false,
      },
    },
  },
  ldsService: {
    Class: DefaultLdsService,
    params: {
      system: LdsSystem.Health,
      legals: ldsSettings,
    },
  },
});

export const getData = (
  ldsSettings: Legal[],
  fieldsSettings: AuthConfig['fieldsSetup'],
  customTranslations: AuthConfig['translations'],
  loginSettings: LoginSettings | null | undefined
) => ({
  config: {
    fieldsSetup: fieldsSettings,
    translations: customTranslations,
  },
  services: getServices(ldsSettings, loginSettings),
});
